module.exports = __webpack_public_path__ + "img/guanzhu.142b1679.png";